<template>
  <jet-form-section @submitted="updateProfileInformation">
    <template #title> {{ t("title") }} </template>

    <template #description>
      {{ t("description") }}
    </template>

    <template #form>
      <div class="col-span-6 sm:col-span-4">
        <ui-input
          :invalid="'name' in form.errors"
          :error="form.errors.name"
          type="text"
          :label="t('name')"
          v-model="form.name"
        ></ui-input>
      </div>

      <div class="col-span-6 sm:col-span-4">
        <ui-input
          :invalid="'email' in form.errors"
          :error="form.errors.email"
          type="email"
          :label="t('email')"
          v-model="form.email"
        ></ui-input>
      </div>
    </template>

    <template #actions>
      <ui-button :disabled="form.processing">
        {{ t("save") }}
      </ui-button>
    </template>
  </jet-form-section>
</template>

<script>
import JetFormSection from "@/Jetstream/FormSection";
import { useI18n } from "vue-i18n";

export default {
  components: {
    JetFormSection,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: ["user"],

  data() {
    return {
      form: this.$inertia.form({
        _method: "PUT",
        name: this.user.name,
        email: this.user.email,
        photo: null,
      }),

      photoPreview: null,
    };
  },

  methods: {
    updateProfileInformation() {
      if (this.$refs.photo) {
        this.form.photo = this.$refs.photo.files[0];
      }

      this.form.post(route("user-profile-information.update"), {
        errorBag: "updateProfileInformation",
        preserveScroll: true,
      });
    },

    selectNewPhoto() {
      this.$refs.photo.click();
    },

    updatePhotoPreview() {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.photoPreview = e.target.result;
      };

      reader.readAsDataURL(this.$refs.photo.files[0]);
    },

    deletePhoto() {
      this.$inertia.delete(route("current-user-photo.destroy"), {
        preserveScroll: true,
        onSuccess: () => (this.photoPreview = null),
      });
    },
  },
};
</script>


<i18n>
{
  "es": {
    "title": "Información de perfil",
    "description": "Actualiza la información de perfil de tu cuenta y tu correo electrónico.",
    "name": "Nombre",
    "email": "Correo electrónico",
    "save": "Guardar"
  }
}
</i18n>
